import React, { Suspense } from 'react'
import Header from 'src/components/Header/Header'
import HiddenList from './HiddenList'
import Loading from 'src/components/Loading/Loading'
import './Hidden.sass'

const Hidden = () => {

  return (
    <div className="page" id="hidden-assets">
      <Header />
      <section className="container hidden-actives">
        <Suspense fallback={<Loading />}>
          <HiddenList />
        </Suspense>
      </section>
    </div>
  )

}

export default Hidden
